module.exports = __webpack_public_path__ + "img/evaluating_img19120601.679ef298.jpg";